import React, { Component } from 'react';

export default class FinancialPlanWrapperView extends Component {
  UNSAFE_componentWillMount() {
    const { fetch_data, fpId, clientId } = this.props;
    if (!fpId) {
      fetch_data(clientId);
    }
  }

  componentDidMount() {
    const { goalId, clientId, setGoal } = this.props;

    if (clientId && goalId) {
      setGoal(goalId, clientId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.fpId === prevProps.fpId && this.props.goalId !== prevProps.goalId) {
      this.props.setGoal(this.props.goalId, this.props.clientId);
    }
  }

  renderChildren() {
    const {
      children,
      fpId,
      goalId,
      clientId,
      isPrint,
      printDone,
      IsPdf,
      subGoalTypeId,
      title,
    } = this.props;

    return React.Children.map(children, child =>
      React.cloneElement(child, {
        goalId,
        fpId,
        clientId,
        isPrint,
        printDone,
        IsPdf,
        subGoalTypeId,
        title,
      }),
    );
  }

  render() {
    const { fpId } = this.props;
    return fpId ? this.renderChildren() : null;
  }
}
